import tw, { styled } from "twin.macro"

export const Wrapper = styled.footer`


  ${tw`flex items-center justify-center text-center text-white bg-darkgray py-10`}

  div.box{

    .brand-name{
      ${tw`text-white text-3xl font-bold mb-4`}
    }

    ${tw`flex flex-col sm:flex-row justify-between w-full max-w-screen-xl px-8 xl:px-0`}

    div.left-block{
      ${tw`flex flex-col items-start`}

      .logo{
        ${tw`mb-6 sm:mb-8 w-full mx-auto md:max-w-min	`}
        max-width: 21rem;
      }

      .desktop-only{
        ${tw`text-left`}
      }


    }

    div.right-block{

      ${tw`flex flex-col-reverse sm:flex-row`}

      div.content-block{
        ${tw`flex flex-col items-center sm:items-end sm:w-auto mx-auto sm:mx-0`}

        @media (max-width: 640px){
          max-width: 256px;
        }

        .social{
          ${tw`mb-6`}
        }
      }
    }

    p {
      ${tw`m-0 p-0 font-opensans`}
    }

    .desktop-only{
      ${tw`hidden sm:block`}
    }
    .mobile-only{
      ${tw`block sm:hidden font-opensans text-xs py-6`}
    }

    ul{
      ${tw`sm:flex sm:justify-end`}
    }
  }

  .kinetixuniversity{
    ${tw`text-white no-underline border-0 border-b border-solid border-gray pb-6 sm:pb-0 w-5/6`}
  }

`;


